module.exports = __webpack_public_path__ + "static/img/Roboto-Regular.8681f43.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/roboto-fontface/fonts/roboto/Roboto-Regular.svg
// module id = G8YZ
// module chunks = 3